// extracted by mini-css-extract-plugin
export default {"container":"Confirmation_container__VUQTf","inner":"Confirmation_inner__r5l5G","welcome":"Confirmation_welcome__yq+Tv","setUp":"Confirmation_setUp__YbF4q"};